import { render, staticRenderFns } from "./PostTippingModal.vue?vue&type=template&id=f0cf0052&scoped=true&"
import script from "./PostTippingModal.vue?vue&type=script&lang=ts&"
export * from "./PostTippingModal.vue?vue&type=script&lang=ts&"
import style0 from "./PostTippingModal.vue?vue&type=style&index=0&id=f0cf0052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cf0052",
  null
  
)

export default component.exports